export default __webpack_public_path__ + "static/media/GF_LIV_MYST.ebdf16e3.jpg";